/**
 * **Bookvisit**
 *
 * Official: www.bookvisit.com
 *
 * Example: <a href="https://puertacatedral.com/en/apartments/puerta-catedral-suites/" target="_blank">Puerta Catedral Suites</a>
 *
 * @exports bs_73
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    let bookvisitObserver;
    /**
       *
       * @memberOf module:bs_73
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot(ctx) {
        if (thn.data.propertyId === 1015322) { // Villa Kallhagen
            if (thn.isIframed()) {
                // [iframe] When iframe script, dispatch a message to the parent (we're now inside IBE)
                window.parent.postMessage({ action: 'thn_page_unload' }, '*');
            }
            else {
                // [parent] Observe to detect the injection of the iframe (IBE)
                //
                // Observe the body for child addition/removal
                // Our target here is an iframe whose classList contains 'bv-fancybox-desktop'.
                thn.observeDom(document.getElementsByTagName('body')[0], function (mutations) {
                    let updateFunction;
                    let bookvisitContent;
                    Array.from(mutations).forEach(function (mutation) {
                        Array.from(mutation.addedNodes).forEach(function (node) {
                            if (!node.classList || !node.classList.contains('bv-fancybox-desktop')) {
                                return;
                            }
                            // Remove the previous observer
                            if (thn.removeHoteliersObserver) {
                                thn.removeHoteliersObserver();
                                delete thn.removeHoteliersObserver;
                            }
                            // Build a new observer
                            updateFunction = thn.debounce(thn.pageCheck, 400);
                            bookvisitContent = node.childNodes[0];
                            // if '.bv-fancybox-desktop' is visible this is a "Booking Iframe" page
                            thn.observeDom(bookvisitContent, updateFunction, {
                                childList: false,
                                subtree: false,
                                characterData: false,
                                attributes: true,
                                attributesFilter: ['class'],
                            });
                            // First time it fires, check the page to get to the `Booking Iframe'
                            updateFunction();
                            thn.removeBookvisitObserver = function removeBookvisitObserver() {
                                thn.stopObserveDom(bookvisitContent, updateFunction);
                            };
                        });
                        // When the iframe is removed, check the page again to return to the previous one.
                        Array.from(mutation.removedNodes).forEach(function (node) {
                            if (!node.classList || !node.classList.contains('bv-fancybox-desktop')) {
                                return;
                            }
                            thn.pageCheck();
                        });
                    });
                }, {
                    childList: true,
                    subtree: true,
                    characterData: false,
                });
            }
        }
    };
    /**
       * @memberOf module:bs_73
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        // https://book.ligula.se/v2/widget/WidgetNewWindowStart?channelId=0500f91b-373f-4e3c-ab63-1c525a142a82&year=2023&month=7&day=5&stayLength=3&roomConfig=a2&promoCode=&corpCode=&iataCode=&guestRoomId=&packageId=&packageCategoryId=&campaignId=&allPackages=False&isMultiPropertyPackageCategory=&geoNodeId=&forExtras=false&accommodationType=undefined&culture=sv&currency=SEK
        const channelId = document.querySelector('#ChannelId')?.value;
        if (channelId) {
            ctx.newUrl = `https://book.ligula.se/v2/widget/WidgetNewWindowStart?channelId=${channelId}&year=[arrivalYear]&month=[arrivalMonth]&day=[arrivalDay]&stayLength=[nights]&roomConfig=a2&promoCode=&corpCode=&iataCode=&guestRoomId=&packageId=&packageCategoryId=&campaignId=&allPackages=False&isMultiPropertyPackageCategory=&geoNodeId=&forExtras=false&accommodationType=undefined&culture=[language]&currency=[currency]`;
            const dateBegin = ctx.newData?.date_begin || ctx.data?.date_begin;
            const dateEnd = ctx.newData?.date_end || ctx.data?.date_end;
            if (dateBegin && dateEnd) {
                const dateBeginParts = dateBegin?.split(/[-/\\]/);
                ctx.newData.arrivalDay = dateBeginParts[2];
                ctx.newData.arrivalMonth = dateBeginParts[1];
                ctx.newData.arrivalYear = dateBeginParts[0];
                ctx.newData.nights = thn.daysBetween(dateBegin, dateEnd) || ctx.data?.nights;
            }
        }
        else {
            ctx.newUrl = ''; // not enough info to generate the url
        }
        return ctx;
    };
    /**
       * @memberOf module:bs_73
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            thn.domReady().then(function () {
                const ligulaData = window.GLOBAL_LIGULA;
                let lang = document.querySelector('.cb-js-langpicker-trigger > img');
                lang = lang?.getAttribute('src')?.match(/([^/]+)\.png$/)[1]?.substr(0, 2);
                if (lang && ctx.langs.test(lang)) {
                    lang = lang === 'nb' ? 'no' : lang;
                    resolve(lang);
                    return;
                }
                if (ligulaData) {
                    lang = ligulaData.languageCode;
                    if (lang && ctx.langs.test(lang)) {
                        resolve(lang);
                        return;
                    }
                }
                if (window.location.hostname.match(/geilolia/)) {
                    const language = window.location.pathname.match(ctx.urlRe);
                    lang = language && language[1];
                    if (lang && ctx.langs.test(lang)) {
                        resolve(lang);
                        return;
                    }
                    resolve('no');
                    return;
                }
                if (thn.data.accountUserId === 1037998 && window.location.hostname.match(/^eng/)) {
                    resolve('en');
                    return;
                }
                // // Gjestehuset 102 hotel & Smarthotels
                if ([1040367, 1044243].includes(thn.data.accountUserId)) {
                    lang = document.documentElement?.getAttribute('lang')?.split('-')[0];
                    if (lang && ctx.langs.test(lang)) {
                        lang = lang === 'nb' ? 'no' : lang;
                        resolve(lang);
                        return;
                    }
                }
                const menuBookingEl = document.querySelector('.menu-accommodation');
                const OnyxenHotelCheck = thn.data.propertyId === 1030887 && menuBookingEl;
                if (OnyxenHotelCheck) {
                    lang = menuBookingEl.textContent.toLowerCase().includes('boka rum') ? 'sv' : 'en';
                    resolve(lang);
                    return;
                }
                reject('no_language');
            });
        });
    };
    /**
       * @memberOf module:bs_73
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('.bv-js-direct-book-scroll');
        if (container && !bookvisitObserver) {
            bookvisitObserver = thn.debounce(() => ctx.widget.update(), 500);
            thn.observeDom(container, bookvisitObserver, {
                childList: true,
                subtree: true,
            });
            thn.pageUnload(() => {
                bookvisitObserver.cancel();
                thn.stopObserveDom(container, bookvisitObserver);
                bookvisitObserver = null;
            });
        }
    };
    /**
       *
       * Implements **no_rooms**
       *
       * @memberOf module:bs_73
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const dataLayer = window.dataLayer;
        const isPuertaCatedral = thn.data.accountUserId === 1033114;
        // SmartHotel UID 1044243 wants the page showing the prices for each room type to be detected as R & R.
        const roomTypeListPage = window.location.pathname.match(/accommodation\/room-details/);
        let prices;
        const $ = window.jQuery || window.bvjQuery;
        if (!$) {
            return widgetData;
        }
        if (window.location.pathname.match(/package/)) {
            widgetData.price_special = 1;
        }
        //* Dates
        const dateBegin = thn.dateToString(thn.objectGet(dataLayer, 'start_date'));
        const dateEnd = thn.dateToString(thn.objectGet(dataLayer, 'end_date'));
        const nightsRaw = document.querySelector('.bv-details div:nth-child(1) div:nth-child(2)')?.textContent;
        let nights = thn.parseNumber(nightsRaw);
        const checkinYear = document.querySelector('#bv-js-arrvial-date-year, #bv-js-check-in-date-year')?.value;
        let checkinMonth = document.querySelector('#bv-js-arrvial-date-month, #bv-js-check-in-date-month')?.value;
        let checkinDay = document.querySelector('#bv-js-arrvial-date-day, #bv-js-check-in-date-day')?.value;
        if (dateBegin && dateEnd) {
            widgetData.date_begin = dateBegin;
            widgetData.date_end = dateEnd;
            nights = thn.daysBetween(widgetData.date_begin, widgetData.date_end);
        }
        else if (checkinDay && checkinMonth && checkinYear) {
            checkinDay = `0${checkinDay}`.slice(-2);
            checkinMonth = `0${checkinMonth}`.slice(-2);
            const dateBeginParsed = `${checkinYear}/${checkinMonth}/${checkinDay}`;
            widgetData.date_begin = dateBeginParsed;
            widgetData.date_end = nights && thn.dateToString(thn.addDays(dateBeginParsed, nights));
            if (!widgetData.date_end) {
                widgetData.date_end = document.querySelector('.bv-state-departure input')?.value?.replace(/-/g, '/');
                nights = widgetData.date_end && thn.daysBetween(widgetData.date_begin, widgetData.date_end);
            }
        }
        //* Guests
        widgetData.adults = parseInt($('.bv-js-SelectedNrAdults:eq(0)').val(), 10) || 2;
        widgetData.children = parseInt($('.bv-js-SelectedNrChildren:eq(0)').val(), 10) || 0;
        widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);
        //* Price
        const extraSelector = isPuertaCatedral
            ? '.bv-descr:contains("Suite Superior"):not(:contains("Suites")) ' : '';
        if (isPuertaCatedral) {
            prices = document.querySelectorAll(`${extraSelector}.bv-side-pricing .bv-txt-discount:visible`);
        }
        else if (document.querySelectorAll('h2.bv-js-cheapest-alt').length) {
            prices = document.querySelectorAll('h2.bv-js-cheapest-alt');
        }
        else if (document.querySelectorAll('.bv-js-list-room .bv-txt-price').length) {
            prices = document.querySelectorAll('.bv-js-list-room .bv-txt-price');
        }
        else if (document.querySelectorAll('.bv-pricing h3').length) {
            prices = document.querySelectorAll('.bv-pricing h3');
        }
        else if (roomTypeListPage) {
            prices = document.querySelectorAll('b.bv-txt-discount, .bv-pricing b');
        }
        else {
            prices = document.querySelectorAll('.bv-side-pricing .bv-txt-discount');
        }
        const pricesArray = [...prices].map((price) => thn.parseNumber(price?.textContent.trim()));
        const bestPrice = pricesArray.sort((curr, next) => curr - next)[0];
        const $currencyEl = $('.bv-currency span');
        const currency = $currencyEl[0]?.textContent.trim()
            || $('.bv-gui-icntxt > .cb-js-codepicker-trigger > span').text()
            || $('#bv-js-currency').val();
        if (currency) {
            widgetData.currency = currency;
        }
        if (bestPrice && nights) {
            widgetData.price = bestPrice / nights;
        }
        if (roomTypeListPage) {
            widgetData.price_special = 1;
        }
        if (window.location.pathname.match(/no-result/)) {
            widgetData.no_rooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_73
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const booking = window.booking;
        if (booking && booking.BookingCode) {
            widgetData.booking_id = booking.BookingCode;
        }
        if (!widgetData.booking_id) {
            widgetData.booking_id = document.querySelector('b.bv-txt-required')?.textContent?.trim();
        }
        const priceEl = document.querySelector('.bv-value .bv-txt-discount') || document.querySelector('.bv-value .bv-txt-strike');
        const price = priceEl?.textContent;
        const total = thn.parseNumber(thn.dataLayerHelper.get('transactionTotal') || booking?.TotalAmount);
        if (total && price) {
            // For hotels not using NOK or SEK currency, we were parsing wrongly the prices when booking for more than 1 night
            widgetData.price = total;
            widgetData.currency = window.currency || thn.parseCurrency(price);
        }
        else if (price) {
            widgetData.price = thn.parseNumber(price);
            widgetData.currency = thn.parseCurrency(price);
        }
        // dates
        if (booking && booking.Products && booking.Products.length && booking.Products[0].Start) {
            widgetData.date_begin = booking.Products[0].Start.replace(/(\d+)\D+(\d+)\D+(\d+).*/, '$1/$2/$3');
        }
        if (booking && booking.Products && booking.Products.length && booking.Products[0].End) {
            widgetData.date_end = booking.Products[0].End.replace(/(\d+)\D+(\d+)\D+(\d+).*/, '$1/$2/$3');
        }
        widgetData.promocode = document.querySelector('input[name="PromoCode"]')?.value;
        return widgetData;
    };
    /**
       * @memberOf module:bs_73
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const promocode = ((document.querySelector('#PromoCode') || {}).value) || ((document.querySelector('.bv-code-valid') || {}).textContent || '').trim();
        if (promocode) {
            ctx.promocode = promocode;
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
